import {
  Button,
  Card,
  Checkbox,
  Flex,
  Form,
  Input,
  Result,
  Space,
  Spin,
  Typography,
} from 'antd';

import { YooKassaLogo } from '@app/assets';
import {
  EMAIL_LENGTH_VALIDATION,
  EMAIL_TYPE_VALIDATION,
  RULES_IS_REQUIRE,
} from '@app/constants';
import { PREFIX } from '@app/constants/appPrefix';
import {
  useYooKassaPaymentWithEmail,
  useYooKassaPaymentWithEmailEffects,
} from '@app/pages/YooKassa/components/YooKassaPaymentWithEmail/hooks';
import '@app/pages/YooKassa/components/YooKassaPaymentWithEmail/styles/YooKassaPaymentWithEmail.desktop.scss';

const { Title, Text } = Typography;

interface PaymentFormValues {
  email: string;
}

export const YooKassaPaymentWithEmail = () => {
  const {
    viewState,
    errorMessage,
    confirmationUrl,
    confirmPayment,
    isConfirming,
    form,
  } = useYooKassaPaymentWithEmail();

  useYooKassaPaymentWithEmailEffects({
    shouldRedirect: viewState === 'redirecting',
    confirmationUrl,
  });

  return (
    <div className={`${PREFIX}yoo-kassa-payment-with-email`}>
      <Card className="wrapper-card">
        <Space direction="vertical" size={16} className="space-component">
          <Title level={4} className="main-title">
            Оплата визита
          </Title>

          {viewState === 'noToken' && (
            <Text type="secondary">
              Ссылка на оплату неполная. Попросите менеджера прислать её заново.
            </Text>
          )}

          {(viewState === 'loading' || viewState === 'redirecting') && (
            <Flex justify="center">
              <Spin />
            </Flex>
          )}

          {viewState === 'error' && <Text type="danger">{errorMessage}</Text>}

          {viewState === 'succeeded' && (
            <Result status="success" title="Платёж уже оплачен" />
          )}

          {viewState === 'canceled' && (
            <Result status="warning" title="Платёж отменён" />
          )}

          {viewState === 'form' && (
            <>
              <Form<PaymentFormValues>
                layout="vertical"
                onFinish={confirmPayment}
                form={form}
              >
                <Form.Item
                  label="Укажите почту для получения чека"
                  required
                  name="email"
                  rules={[
                    ...RULES_IS_REQUIRE,
                    EMAIL_TYPE_VALIDATION,
                    EMAIL_LENGTH_VALIDATION,
                  ]}
                >
                  <Input inputMode="email" autoComplete="email" />
                </Form.Item>

                <Form.Item
                  required
                  rules={RULES_IS_REQUIRE}
                  valuePropName="checked"
                  name="agreement"
                >
                  <Checkbox className="checkbox-agreement">
                    <Text type="secondary">
                      Я соглашаюсь на обработку персональных данных в
                      соответствии с политикой конфиденциальности.
                    </Text>
                  </Checkbox>
                </Form.Item>

                <Flex justify="space-between" align="center">
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    loading={isConfirming}
                  >
                    Оплатить
                  </Button>

                  <img
                    src={YooKassaLogo}
                    alt="YooKassa Logo"
                    className="you-kassa-image"
                  />
                </Flex>
              </Form>

              <Text type="secondary">
                Вы будете перенаправлены на защищённый протокол для оплаты в
                ЮKassa.
              </Text>
            </>
          )}
        </Space>
      </Card>
    </div>
  );
};
